import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Button from 'components/controls/Button/Button';
import companyLogo from 'assets/graphics/grazers.svg';
import './Header.css';

const Header: React.FC = () => {
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 20);
		window.addEventListener('scroll', onScroll, { passive: true });
		onScroll(); // check initial position
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	return (
		<header className={`header ${scrolled ? 'header--scrolled' : ''}`}>
			<div className="header-container">
				<div className="header-nav-container">
					<Navbar />
				</div>
				<div className="header-logo-container">
					<Link to="/">
						<img src={companyLogo} className="logo" alt="The G.O.A.T. Grazers logo" />
					</Link>
				</div>
				<div className="header-cta-container">
					<Button to="/contact" variant="primary" size="sm">
						Get an Estimate
					</Button>
				</div>
			</div>
		</header>
	);
};

export default Header;
